module.exports = __webpack_public_path__ + "static/record_effortlessly-7f41cd02d255c410b88d6b0e00e2d329.png";